<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';
    import { TRANSITION_DELAY } from '$lib/global/constants';

    import { resolveAccordionItemStyling } from './_utils/resolveAccordionItemStyling';
    import AccordionItem from './AccordionItem.svelte';
    import { getBoxAttributes } from '../_utils/getBoxAttributes';
    import Box from '../_wrappers/Box.svelte';

    import type { Box as BoxType } from '$lib/types/Components/SharedTypes';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';
    import type { AdvancedStyling } from '$lib/types/Theming/AdvancedStyling';
    import type { ComponentProps } from 'svelte';

    type Item = {
        id: string;
        title: ComponentProps<AccordionItem>['title'];
        body: ComponentProps<AccordionItem>['body'];
        bgColor?: string;
        advancedStyling?: AdvancedStyling;
    };

    export let id = '';
    export let box: BoxType;
    export let items: Item[] = [];
    export let theme: Theme | undefined = undefined;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let layout = DEFAULT_LAYOUT;

    const { isInColumn } = layout;
</script>

<Box {id} {...getBoxAttributes({ box, isInColumn })} {transitionDelay} {transitionEffect}>
    <div class="fun-grid fun-grid-cols-1 fun-gap-4">
        {#each items as item, index (item.id)}
            <AccordionItem
                title={item.title}
                body={item.body}
                bgColor={item.bgColor}
                styling={resolveAccordionItemStyling({
                    advancedStyling: item.advancedStyling,
                    theme,
                    boxBackgroundColor: item.bgColor,
                })}
                {transitionEffect}
                transitionDelay={transitionDelay + index * TRANSITION_DELAY}
            />
        {/each}
    </div>
</Box>
